$(document).ready(function(){
    
    $(document).on('click', '.show_thumbnails_with_arrows .thumbnail-slider .custom_prev', function(){
        $('product-gallery .slider-button--prev').trigger('click');
    });
    $(document).on('click', '.show_thumbnails_with_arrows .thumbnail-slider .custom_next', function(e) {
        $('product-gallery .slider-button--next').trigger('click');
    });

    setInterval(() => {
        if ($('product-gallery .slider-button--prev').prop('disabled')) {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_prev').addClass('disabled');
        } else {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_prev').removeClass('disabled');
        }
        if ($('product-gallery .slider-button--next').prop('disabled')) {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_next').addClass('disabled');
        } else {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_next').removeClass('disabled');
        }
        
    }, 1000);
    
    function videoAutoplay(){
        let currentVideo = $('.video.thumbnail[aria-current="true"]').closest('.thumbnail-list__item').attr('data-target');
             $('product-gallery .slider__slide').each(function(){
                var mainMedia = $(this).attr('data-media-id');
                if(mainMedia == currentVideo) {
                   $(this).find('.deferred-media__poster').trigger('click');
                   $(this).find('video').trigger('play');
                }
                
             });
    }
    
    $(document).on('click', 'thumbnail-slider .custom_arrow', function(){
        setTimeout(() => {
             videoAutoplay();
        }, 1200);
    })
    $(document).on('click', 'product-gallery .slider-button', function(){
        setTimeout(() => {
             let currentVideo = $('.video.thumbnail[aria-current="true"]').closest('.thumbnail-list__item').attr('data-target');
             $('product-gallery .slider__slide').each(function(){
                var mainMedia = $(this).attr('data-media-id');
                if(mainMedia == currentVideo) {
                   $(this).find('.deferred-media__poster').trigger('click');
                   $(this).find('video').trigger('play');
                }
                
             });
        }, 1200);
    });

//     var tumblength = $('thumbnail-slider .thumbnail-list li').length();
// console.log(tumblength);



function hideShowVariantsImage(){

var currentVariantSelect = '';

$('.custom_hide_show_varaint_images variant-selects .product-form__input input:checked').each(function(){
    let singleOption = $(this).val();
    currentVariantSelect += singleOption + ' ';
    console.log(singleOption);
});

console.log(currentVariantSelect.trim());

$('.custom_hide_show_varaint_images product-gallery .product__media-list .product__media-item').attr('data-gang-option', '');
$('.custom_hide_show_varaint_images product-gallery .product__media-list .product__media-item').each(function(){
    var GetAlt = $(this).attr('alt');
    if(GetAlt == currentVariantSelect.trim()){
        $(this).addClass('gang__active');
    }else {
        $(this).removeClass('gang__active');
    }
});

$('.custom_hide_show_varaint_images .thumbnail-slider .thumbnail-list .thumbnail-list__item').attr('data-gang-option', '');
$('.custom_hide_show_varaint_images .thumbnail-slider .thumbnail-list .thumbnail-list__item').each(function(){
    var GetAlt = $(this).attr('alt');
    if(GetAlt == currentVariantSelect.trim()){
        $(this).addClass('gang__active');
    }else {
        $(this).removeClass('gang__active');
    }
}); 

}

hideShowVariantsImage();

$(document).on('click', 'variant-selects .product-form__input label', function(){
    hideShowVariantsImage(); 
  
})


});